import {  Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { BaseModalDirective } from '../base-modal';
//import { GlobalTranslateService } from '../../../services/globalTranslate/globalTranslate.service';
import { ApplicationService } from "@app/services/application/application.service";
import { TranslateService } from "@ngx-translate/core";
import { Router, ActivatedRoute } from '@angular/router';
declare let gtag: Function;
@Component({
  selector: 'nh-translate-modal',
  templateUrl: './translate-modal.component.html',
  styleUrls: ['./translate-modal.component.scss'],
  standalone: false
})


export class TranslateModalComponent extends BaseModalDirective implements OnInit {
  public selectedGlobalLang: string = 'en';
  public previousLang: string = 'en';  // Track the source language
  defaultLanguage;
  globalLanguage;
  //globalLanguages = []
  public globalLanguages: { LanguageCode : string, LanguageName: string}[] = []
  constructor(
      protected modalRef: BsModalRef, 
      protected application: ApplicationService,
      protected builder: FormBuilder,
      private translate: TranslateService,
      private router: Router,
      private activatedRoute: ActivatedRoute
      ) {
    super(modalRef, builder);
  }
  
  ngOnInit() {
    // Get current language from session storage, default to 'en'
    // Check AWS translated language first, then check ngx-translate language
    let currentLang = sessionStorage.getItem('globalTranslatedLan');
    
    if (!currentLang || currentLang === 'undefined') {
      // Check ngx-translate language (en or sp)
      const ngxLang = sessionStorage.getItem('currentLang');
      // Map 'sp' to 'es' for the modal
      currentLang = ngxLang === 'sp' ? 'es' : (ngxLang || 'en');
    }
    
    this.selectedGlobalLang = currentLang;
    this.previousLang = currentLang;  // Store initial language
    this.fetchAllLanguages();
  }

  fetchAllLanguages() {
   // Use hardcoded list of supported languages
   this.globalLanguages = 
   [{'LanguageCode': 'en', 'LanguageName': 'English'}, 
    {'LanguageCode': 'es', 'LanguageName': 'Spanish (Español)'},
    {'LanguageCode': 'ar', 'LanguageName': 'Arabic (العربية)'},
    {'LanguageCode': 'zh', 'LanguageName': 'Chinese (中文)'},
    {'LanguageCode': 'vi', 'LanguageName': 'Vietnamese (Tiếng Việt)'},
    {'LanguageCode': 'ko', 'LanguageName': 'Korean (한국어)'},
    {'LanguageCode': 'fr', 'LanguageName': 'French (Français)'},
    {'LanguageCode': 'am', 'LanguageName': 'Amharic (አማርኛ)'},
    {'LanguageCode': 'gu', 'LanguageName': 'Gujarati (ગુજરાતી)'},
    {'LanguageCode': 'de', 'LanguageName': 'German (Deutsch)'},
    {'LanguageCode': 'tl', 'LanguageName': 'Tagalog'},
    {'LanguageCode': 'hi', 'LanguageName': 'Hindi (हिंदी)'},
    {'LanguageCode': 'ru', 'LanguageName': 'Russian (Русский)'},
    {'LanguageCode': 'ja', 'LanguageName': 'Japanese (日本語)'},
    {'LanguageCode': 'fa', 'LanguageName': 'Persian (فارسی)'}];
   }

  getFirstColumnLanguages() {
    const midpoint = Math.ceil(this.globalLanguages.length / 2);
    return this.globalLanguages.slice(0, midpoint);
  }

  getSecondColumnLanguages() {
    const midpoint = Math.ceil(this.globalLanguages.length / 2);
    return this.globalLanguages.slice(midpoint);
  }

  selectLanguage(languageCode: string) {
    this.selectedGlobalLang = languageCode;
    this.translateToGlobal();
  }

    setLanguage(selectedLang: string) {
    this.defaultLanguage = this.translate.getDefaultLang();
    this.globalLanguage = sessionStorage.getItem('globalTranslatedLan') ? sessionStorage.getItem('globalTranslatedLan') : null;
    sessionStorage.removeItem('globalTranslatedLan');
    if (this.defaultLanguage === 'en' && this.globalLanguage  === null &&  selectedLang === 'es') {
      this.translate.setDefaultLang('sp');
      this.defaultLanguage = 'sp';
      sessionStorage.setItem('currentLang', 'sp');
    } else if (this.defaultLanguage === 'sp' && this.globalLanguage  === null &&  selectedLang === 'en') {
      this.translate.setDefaultLang('en');
      this.defaultLanguage = 'en'
      sessionStorage.setItem('currentLang', 'en');
    }
    location.reload();
  }

  translateToGlobal() {
    const currentUrl = this.router.url;
    const isFaqPage = currentUrl.includes('/faq');
    
    // Update HTML lang attribute for screen readers (NVDA, JAWS, etc.)
    document.documentElement.lang = this.selectedGlobalLang;
    gtag('event', 'globalTranslate', {
      'event_category': 'Global Translate',
      'event_label': 'Changed language via Global Translate',
      'value': this.selectedGlobalLang,
      'from_lang': this.previousLang,
    })
    
    if (this.selectedGlobalLang !== 'en' && this.selectedGlobalLang !== 'es') {
      // Store selected language in session storage
      sessionStorage.setItem('globalTranslatedLan', this.selectedGlobalLang);

      // If on FAQ page, update URL with lang query parameter
      if (isFaqPage) {
        // Preserve existing query params
        const urlPath = currentUrl.split('?')[0];
        if (this.previousLang === 'es' && this.globalLanguage !== null) {
          this.translate.setDefaultLang('en');
          this.defaultLanguage = 'en'
          sessionStorage.setItem('currentLang', 'en');
        }
        const queryParams = { ...this.activatedRoute.snapshot.queryParams, lang: this.selectedGlobalLang };
        this.router.navigate([urlPath], { queryParams }).then(() => {
          location.reload();
        });
      } else {
        // Reload page to apply translations via globalTranslatePipe
        this.translate.setDefaultLang('en');
        this.defaultLanguage = 'en'
        sessionStorage.setItem('currentLang', 'en');
        location.reload();
      }
    } else {
      // Remove translation and reload to show English
      sessionStorage.removeItem('globalTranslatedLan');
      
      // If on FAQ page, update URL with lang query parameter
      if (isFaqPage) {
        const urlPath = currentUrl.split('?')[0];
        const queryParams = { ...this.activatedRoute.snapshot.queryParams, lang: this.selectedGlobalLang };
        this.router.navigate([urlPath], { queryParams }).then(() => {
          this.setLanguage(this.selectedGlobalLang);
        });
      } else {
        this.setLanguage(this.selectedGlobalLang);
      }
    }
  }
  


  onCancel(): void{
    this.hide('');
  }
}